import * as React from "react"

const Plus = (props) => {
    const { color, size } = props
    return (<svg width={size ? size : "1200pt"} height={size ? size : "1200pt"} version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" alt="Plus icon">
    <path fill={color} fillRule="evenodd" d="m985.2 696h-289.2v289.2c0 52.801-43.199 96-96 96s-96-43.199-96-96v-289.2h-289.2c-52.801 0-96-43.199-96-96s43.199-96 96-96h289.2v-289.2c0-52.801 43.199-96 96-96s96 43.199 96 96v289.2h289.2c52.801 0 96 43.199 96 96s-43.199 96-96 96z"/>
   </svg>)
}

export default Plus